import { render, staticRenderFns } from "./ProjectContentQnA.vue?vue&type=template&id=3272ab22"
import script from "./ProjectContentQnA.vue?vue&type=script&lang=ts"
export * from "./ProjectContentQnA.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports